import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Tag from "../components/Tag";
import Select from "../components/Select";
import OrderFilter from "../components/OrderFilter";
import SortingBar from "../components/SortingBar";
import { InsertOrderDialog } from "pages/InsertOrder";
import axiosBackend from "../api/axiosBackend";

// shadcn
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "components/ui/card";
import { Button } from "components/ui/button";
import { Separator } from "components/ui/separator";

const Order = () => {
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({});
  const [sortParams, setSortParams] = useState({ sortField: "", sortOrder: "" });
  const [showFilter, setShowFilter] = useState(true);

  // Status options
  const statusOptions = [
    { value: "all", label: "כל הסטטוסים" },
    { value: "pending", label: "ממתין" },
    { value: "inProgress", label: "בתהליך" },
    { value: "done", label: "הסתיים" },
  ];

  const colorMap = {
    pending: "#A8D5BA",
    inProgress: "#FFD59E",
    done: "#F7A8A8",
  };

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await axiosBackend.put(`/orders/change-status/${orderId}`, { status: newStatus });
      setOrders((prev) =>
        prev.map((o) => (o._id === orderId ? { ...o, status: newStatus } : o))
      );
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axiosBackend.get("/orders/get", {
          params: { ...filters, ...sortParams },
          withCredentials: true,
        });
        setOrders(response.data.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [filters, sortParams]);

  const handleFilter = (newFilters) => setFilters(newFilters);
  const handleSortChange = (sortConfig) => setSortParams(sortConfig);

  // helper to convert saved label back to value (keeping your existing shape)
  const findKeyByValue = (arr, value) => {
    const entry = arr.find((item) => item.label === value);
    return entry ? entry.value : undefined;
  };

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <div className="container mx-auto px-4 py-4">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold">הזמנות</h1>
          <div className="flex gap-2">
            <Button variant="secondary" onClick={() => setShowFilter((s) => !s)}>
              {showFilter ? "הסתר מסננים" : "הצג מסננים"}
            </Button>
            <InsertOrderDialog onCreated={(order) => {setOrders((prev) => {
              const newOrders = [...prev, order]
                return newOrders;})}} />
          </div>
        </div>

        {showFilter && (
          <Card className="mb-4">
            <CardContent className="pt-6">
              <OrderFilter onFilter={handleFilter} setShowFilter={setShowFilter} />
            </CardContent>
          </Card>
        )}

        <Card className="mb-4">
          <CardContent className="pt-4">
            <SortingBar onSortChange={handleSortChange} />
          </CardContent>
        </Card>

        {/* Responsive grid for orders */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {orders.map((order) => (
            <Card key={order._id} className="overflow-hidden">
              <CardHeader className="pb-3">
                <div className="flex items-start justify-between gap-3">
                  <CardTitle className="text-lg">{order.name}</CardTitle>
                  <div className="min-w-[160px]">
                    <Select
                      options={statusOptions}
                      initialValue={findKeyByValue(statusOptions, order.status)}
                      onOptionChange={(newStatus) => handleStatusChange(order._id, newStatus)}
                      colorMap={colorMap}
                    />
                  </div>
                </div>
              </CardHeader>

              <Separator />

              <CardContent className="space-y-1 pt-4">
                <p className="text-sm text-muted-foreground">
                  <span className="font-medium text-foreground">מספר פלאפון:</span> {order.phone}
                </p>
                <p className="text-sm text-muted-foreground">
                  <span className="font-medium text-foreground">מוצר:</span> {order.product}
                </p>
                <p className="text-sm text-muted-foreground">
                  <span className="font-medium text-foreground">הערות:</span> {order.comments}
                </p>
                <p className="text-sm text-muted-foreground">
                  <span className="font-medium text-foreground">תאריך:</span>{" "}
                  {new Date(order.date).toLocaleDateString()}
                </p>

                {/* Tags */}
                {order.tags?.length > 0 && (
                  <div className="mt-3 flex flex-wrap gap-2">
                    {order.tags.map((tag) => (
                      <Tag key={tag._id} name={tag.name} />
                    ))}
                  </div>
                )}
              </CardContent>

              <CardFooter>
                <Button asChild className="w-full">
                  <Link to={`/order_edit/${order._id}`}>ערוך הזמנה</Link>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Order;
